import { render, staticRenderFns } from "./ProjectCreateEditWidget.vue?vue&type=template&id=2b6a4518&scoped=true&"
import script from "./ProjectCreateEditWidget.vue?vue&type=script&lang=js&"
export * from "./ProjectCreateEditWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreateEditWidget.vue?vue&type=style&index=0&id=2b6a4518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a4518",
  null
  
)

export default component.exports